import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { GridApi, ColDef, IDateFilterParams, ICellRendererParams, StateUpdatedEvent } from 'ag-grid-community';
import { ConsolidationRowDetailsComponent } from './consolidation-row-details/consolidation-row-details.component';
import { MenuComponent } from '../menu/menu.component';
import { Router } from '@angular/router';
import { Consolidation } from '../models/consolidation.model';
import { consolidationDefaultGridState } from '../default-grid-states/consolidation-default-grid-state';
import { UserGridStateService } from '../user-grid-state.service';
/*
Jennifer's note to self:
date filtering doesn't work. maybe timezones need to be changed.. check the order details component for how to do that, maybe.
*/

@Component({
  selector: 'app-consolidations',
  templateUrl: './consolidations.component.html',
  styleUrls: ['./consolidations.component.scss']
})
export class ConsolidationsComponent {
  public gridReady = false;
  private gridApi!: GridApi;
  rows!: any;
  public detailCellRenderer: any = ConsolidationRowDetailsComponent;
  public detailCellRendererParams = { onDismantled: () => this.updateGridData() };
  public themeClass: string = "ag-theme-ulaap";
  defaultColDef = {
    sortable: true,
    filter: 'agTextColumnFilter',
    filterParams:{
      caseSensitive: false,
    },
    autoHeight: true,
    resizable: true
  }
  public initialState = JSON.parse(JSON.stringify(consolidationDefaultGridState));

  manifests: Consolidation[] = []

  public rowGroupPanelShow: "always" | "onlyWhenGrouping" | "never" = "always";

  public autoGroupColumnDef: ColDef = {
    minWidth: 200,
  };

  constructor(private http: HttpClient, private gridStateService: UserGridStateService){}

  onGridReady(params: any){
    this.gridApi = params.api;
    // this.gridApi.sizeColumnsToFit();
  }

  ngOnInit(){
    this.updateGridData();
    this.fetchAndApplyGridState();
  }

  updateGridData(){
    const url = '/api/consolidations/consolidations_grid.php';
    this.http.get(url).subscribe((response: any) => {
      //console.log(JSON.stringify(response.data.data))
      if(response){
        this.manifests = response.data.data;
        //console.log('updateGridData(): got a response: ', JSON.stringify(response));
      }
      else{
        //console.log('updateGridData(): no response')
      }
    })
  }

  fetchAndApplyGridState(){
    this.gridStateService.getUserGridState('consolidations').subscribe((state) => {
      if(state){
        this.initialState = state;
      }
      this.gridReady = true;
    }, error => {
      console.error('Failed to fetch grid state:', error);
      this.gridReady = true;
    })
  }

  onStateUpdated(params: StateUpdatedEvent<Consolidation>){
    if(params.sources.indexOf('columnSizing') > -1 || params.sources.indexOf('columnOrder') > -1 || params.sources.indexOf('filter') > -1){
      this.gridStateService.saveUserGridState('consolidations', params.state)
    }
  }

  clearFilter(){
    this.gridApi.setFilterModel(null);
    this.gridApi.onFilterChanged();
  }

  // for filtering dates
  filterParams: IDateFilterParams = {
    comparator: (filterLocalDateAtMidnight: Date, cellValue: string) => {
      let dateAsString = cellValue;
      if (dateAsString == null)
        return -1;
      let dateParts = dateAsString.split("-");
      let cellDate = new Date(
        Number(dateParts[0]),
        Number(dateParts[1]) - 1,
        Number(dateParts[2])
      );
      if(filterLocalDateAtMidnight.getTime() === cellDate.getTime()){
        return 0;
      }
      if (cellDate < filterLocalDateAtMidnight){
        return -1;
      }
      if (cellDate > filterLocalDateAtMidnight){
        return 1;
      }
      return 0;
    }
  }

  // headers for the packages grid
  columnDefs: ColDef[] = [
    { field: 'alternate_reference', headerName: 'Master Order', cellRenderer: 'agGroupCellRenderer'},
    { field: 'carrier_name', enableRowGroup: true, headerName: 'Carrier' },
    { field: 'pro_bill', enableRowGroup: true, headerName: 'Pro Bill' },
    { field: 'shipper_locality', enableRowGroup: true, headerName: 'Pickup City' },
    { field: 'shipper_region', enableRowGroup: true, headerName: 'Pickup Region' },
    { field: 'consignee_locality', enableRowGroup: true, headerName: 'Delivery City' },
    { field: 'consignee_region', enableRowGroup: true, headerName: 'Delivery Region' },
    { field: 'load_start', enableRowGroup: true, headerName: 'Pickup Date', filter: 'agDateColumnFilter',
      valueGetter: params => {
        const datetime = new Date(params.data.load_start);
        return datetime.toISOString().split('T')[0];
      },
      filterParams: this.filterParams //if filter params is removed, date filtering won't work
    },
    { field: 'load_end', enableRowGroup: true, headerName: 'Delivery Date', filter: 'agDateColumnFilter',
      valueGetter: params => {
        const datetime = new Date(params.data.load_end);
        return datetime.toISOString().split('T')[0];
      },
      filterParams: this.filterParams
     },
    { field: 'drop_trailer', enableRowGroup: true, headerName: 'Drop Trailer' },
    { field: 'load_pallets', enableRowGroup: true, headerName: 'Pallets' },
    { field: 'load_length', enableRowGroup: true, headerName: 'Load Length' },
    { field: 'load_weight', enableRowGroup: true, headerName: 'Weight' },
    { field: 'delivery_status', enableRowGroup: true, headerName: 'P & D Status' },
    { field: 'consolidation_id', enableRowGroup: true, headerName: 'Consolidation Order' },
    { field: 'lading_consolidation_uuid', headerName: 'Consolidation UUID', hide: false},
    { field: 'lading_uuid', headerName: 'Lading UUID', hide: true},
    { headerName: 'View', width: 100, cellRenderer: ViewMasterOrderDetailsComponent },
    { field: 'actions', headerName: 'Actions', sortable: false, suppressMovable: true, 
      cellRenderer: (parmas: {data: any; node: any}) => {
        const selectCarrierButton = document.createElement('button');
        selectCarrierButton.innerText = 'Select Carrier';
        selectCarrierButton.addEventListener('click', () => alert('click click!'));

        const container = document.createElement('div');
        container.appendChild(selectCarrierButton);
        return container;
      }
    }
  ];

}

@Component({
  selector: 'app-view-master-order-details',
  template: `<span matTooltip="View Order Details"><a matTooltip="View Order Details" [attr.href]="getOrderDetailsLink()"><i class="fa-solid fa-eye"></i></a></span>`,
})
export class ViewMasterOrderDetailsComponent implements ICellRendererAngularComp {

  params: any;

  constructor(private router: Router) { }

  getOrderDetailsLink(): string {
    return `/full-order-details/${this.params.data.lading_uuid}`;
  }

  agInit(params: ICellRendererParams<any, any, any>): void {
    this.params = params;
    //console.log(params);
  }

  refresh(params: ICellRendererParams<any, any, any>): boolean {
    return false;
  }

}
